import getSymbolFromCurrency from 'currency-symbol-map';
import numeral from 'numeral';

export const toCurrencySymbol = (currency = 'MYR') => {
  return getSymbolFromCurrency(currency);
};

export const formatCurrency = (
  amount: string | number = 0,
  options: {
    currency?: string;
    format?: string;
    showSymbol?: boolean;
  } = {
    format: '0,0.00',
    showSymbol: true,
  }
): string | number => {
  const { currency, format, showSymbol } = options;
  const price = numeral(amount).format(format);
  const symbol = showSymbol ? toCurrencySymbol(currency) : currency;
  if (symbol) {
    return `${symbol} ${price}`;
  }
  return price;
};
